import { useMemo } from 'react';
import { useCustomTranslation } from '../../../../hooks';
import { useKanbanEventStore } from '../Kanban';
import { KanbanTaskSearchResult } from './KanbanTaskSearchResult';
import { searchKanbanTasks } from './searchKanbanTasks';
import { SearchResultsList } from './SearchResultsList';
import { useSyncSearchResults } from './useSyncSearchResults';

type KanbanSearchResultsProps = {
  search: string;
};

export const KanbanSearchResults = ({ search }: KanbanSearchResultsProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const selectSearchResults = useMemo(() => searchKanbanTasks(search), [search]);
  const searchResults = useKanbanEventStore(selectSearchResults);

  const matchedIds = useMemo(() => searchResults.map(({ task }) => task.id), [searchResults]);
  useSyncSearchResults(matchedIds);

  return (
    <SearchResultsList bannerMessage={tWrapper('kanbanSearchResultsBanner')} count={searchResults.length}>
      {searchResults.map(({ queue, task, batchName }) => (
        <KanbanTaskSearchResult batchName={batchName} key={`${queue.id}-${task.id}`} queue={queue} task={task} />
      ))}
    </SearchResultsList>
  );
};
